// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import Button from '@tcp/core/src/components/common/atoms/Button/views/Button.jsx';

const radiusSix = (props) => `
    ${
      props.spcBag && props.theme.brand !== 'gym'
        ? `border-radius: ${props.theme.spacing.ELEM_SPACING.XS_6}`
        : ''
    };
`;

const getBgColor = (props) => {
  if (props.coupon?.labelStatus === 'REMOVE' || props.coupon?.labelStatus === 'removing') {
    return `background-color: ${props.theme.colors.WHITE};color:${props.theme.colors.BLACK};`;
  }
  return `background-color: ${props.theme.colors.BLACK};color:${props.theme.colors.WHITE};`;
};

export const CouponButton = styled(Button)`
  border-radius: ${(props) => props.theme.brandSpecificStyles.APPLE_PAY_BUTTON_BORDER_RADIUS};
  width: 73px;
  min-height: 35px;
  margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  font-size: ${(props) => props.theme.typography.fontSizes.fs10};
  font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
  padding: 8px 0px;
  ${(props) => radiusSix(props)};
  ${(props) => getBgColor(props)};

  &:hover,
  &:focus,
  &:disabled:hover {
    ${(props) => getBgColor(props)}
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    min-height: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
  }
`;

const styles = css`
  .couponCard__text_style {
    white-space: nowrap;
    font-size: ${(props) => props.theme.typography.fontSizes.fs10};
    color: ${(props) => props.theme.colorPalette.gray[800]};
    ${(props) =>
      props.isCartPageCouponSection && `font-weight:${props.theme.fonts.fontWeight.semiBold};`}
  }
  .cartDetailsLink {
    position: ${(props) => (props.isCarouselView || props.spc ? 'static' : 'absolute')};
    font-size: ${(props) => props.theme.typography.fontSizes.fs10};
    color: ${(props) => props.theme.colorPalette.gray[800]};
    text-decoration: underline;
    margin-left: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.XS};
  }
  .couponCard__footer_expired {
    text-transform: capitalize;
    display: flex;
    bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    font-size: ${(props) => props.theme.typography.fontSizes.fs11};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    background: ${(props) => props.theme.colorPalette.gray[300]};
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS}
      ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    width: fit-content;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      bottom: 5px;
    }
  }
  .couponCard_applied_footer_expired {
    text-transform: capitalize;
    display: flex;
    bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    font-size: ${(props) => props.theme.typography.fontSizes.fs11};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    color: green;
    background: ${(props) => props.theme.colorPalette.gray[300]};
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS}
      ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    width: fit-content;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXM};
    }
  }
  .couponCard_error_footer_expired {
    display: flex;
    align-items: center;
    bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    font-size: ${(props) => props.theme.typography.fontSizes.fs11};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
    background: ${(props) => props.theme.colorPalette.gray[300]};
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS}
      ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    color: ${(props) => props.theme.colorPalette.red[500]};
    width: fit-content;
    ${(props) => props.isCartPageCouponSection && `width: 90%;`};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      ${(props) => props.isCartPageCouponSection && `width: 90%;`};
    }
  }

  .infoSection {
    display: flex;
    flex-direction: column;
    width: 80%;
  }
  .new-coupon-info-container {
    display: flex;
    justify-content: space-between;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    width: 100%;
  }

  .coupon-icon {
    width: ${(props) => props.theme.spacing.ELEM_SPACING.MED_2};
    height: ${(props) => props.theme.spacing.ELEM_SPACING.MED_2};
    margin-top: ${(props) => props.theme.spacing.APP_LAYOUT_SPACING.XS};
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
  }

  .sub-section {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    display: flex;
  }

  .coupon-title {
    color: #000;
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: ${(props) =>
      props.isNewAccountDrawer
        ? props.theme.typography.fontSizes.fs12
        : props.theme.typography.fontSizes.fs14};
    font-style: normal;
    font-weight: ${(props) => props.theme.typography.fontWeights.demiBold};
    line-height: 150%;
    text-transform: capitalize;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs12};
    }
  }

  .coupon-status {
    font-size: ${(props) => props.theme.typography.fontSizes.fs11};
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
  }

  .new-coupon-container {
    display: flex;
  }

  .link-icon {
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    height: ${(props) => props.theme.typography.fontSizes.fs12};
    width: ${(props) => props.theme.typography.fontSizes.fs12};
    display: flex;
    padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
    justify-content: center;
    align-items: center;
  }
  .spinner-container {
    left: 14%;
    z-index: 2;
  }
  .spc-spinner div {
    background: ${(props) =>
      props?.coupon?.labelStatus === 'removing'
        ? props.theme.colors.BLACK
        : props.theme.colors.WHITE};
  }
  .hide-button {
    visibility: hidden;
  }
`;

export default styles;
